import {fabric} from "fabric-with-gestures";
import Table from "./Table";

const BaseWidth = 75,
  BaseHeight = 75,
  BaseThickness = 9,
  BaseDist = 8,
  BaseLengthChair = 25,
  TableRadius = 10,
  ChairRadius = 5;

export default class Square extends Table {
  width = null;
  height = null;
  length = BaseLengthChair;

  constructor() {
    super();
    this.setDefaultAttr();
  }

  getType(){
    return 'Square';
  }

  setDefaultAttr() {
    this.dist = BaseDist;
    this.width = BaseWidth;
    this.height = BaseHeight;
  }

  getPositionStart(i, groups) {
    let start = groups[i] * this.length + ((groups[i] + 1) * this.dist);
    if (i === 1 || i === 2) {
      start = (this.width - start) / 2;
      start = this.position.left + start + this.dist;
    } else {
      start = (this.height - start) / 2;
      start = this.position.top + start + this.dist;
    }
    return start;
  }

  calculateBusyLine(group) {
    let lengthPerson = this.length * group;
    let lengthDist = this.dist * (group + 1)
    return lengthDist + lengthPerson;
  }

  checkGroupIfExistChairs(i, group) {
    let has = false;
    if (i === 1 || i === 2) {
      let x = this.width - this.calculateBusyLine(group[i]) > this.length + this.dist;
      if (x) {
        has = true;
      }
    } else {
      let x = this.height - this.calculateBusyLine(group[i]) > this.length + this.dist;
      if (x) {
        has = true;
      }
    }
    return has;
  }

  hasFreeChairs(group) {
    let has = false;
    for (let i = 1; i < 5; i++) {
      if (this.checkGroupIfExistChairs(i, group)) {
        has = true;
      }
    }
    return has;
  }

  drawChairs() {
    this.chairs = [];
    let countPerson = this.countPerson;

    let groups = {};
    for (let i = 1; i < 5; i++) {
      groups[i] = 0;
    }

    let counter = 0;
    while (countPerson) {
      counter++;
      if (this.checkGroupIfExistChairs(counter, groups)) {
        groups[counter] += 1;
        countPerson--
      } else {
        if (!this.hasFreeChairs(groups)) {
          this.height = this.height + 2 * this.length;
          this.width = this.width + 2 * this.length;
        }
      }
      if (counter === 4) {
        counter = 0;
      }
    }

    let start;

    start = this.getPositionStart(1, groups);
    while (groups[1]--) {
      this.makeChair(start, this.position.top - BaseThickness + 4, this.length, BaseThickness);
      start += this.length + this.dist;
    }

    start = this.getPositionStart(2, groups);
    while (groups[2]--) {
      this.makeChair(start, this.position.top + this.height - 4, this.length, BaseThickness);
      start += this.length + this.dist;
    }

    start = this.getPositionStart(3, groups);
    while (groups[3]--) {
      this.makeChair(this.position.left + this.width - 4, start, BaseThickness, this.length);
      start += this.length + this.dist;
    }

    start = this.getPositionStart(4, groups);
    while (groups[4]--) {
      this.makeChair(this.position.left - BaseThickness + 4, start, BaseThickness, this.length);
      start += this.length + this.dist;
    }

    return this;
  }

  makeChair(left, top, width, height) {
    this.group.push(
      new fabric.Rect({
        my: {
          id: this.groupId,
          type : 'chair'
        },
        left: left,
        top: top,
        width: width,
        height: height,
        fill: this.colorChair,
        ry: ChairRadius,
        rx: 0,
        objectCaching: false
      })
    );
  }

  drawTable() {
    this.group.push(
      new fabric.Rect({
        my: {
          id: this.groupId,
          type : 'table'
        },
        left: this.position.left,
        top: this.position.top,
        width: this.width,
        height: this.height,
        fill: this.colorTable,
        rx: TableRadius,
        ry: TableRadius,
        objectCaching: false
      })
    );
    return this;
  }
  setControlsVisibility(object){
    object.setControlsVisibility({
      tr: true,
      bl: false,
      tl: false,
      br:false,
      ml: true,
      mt: true,
      mr: true,
      mb: true,
      mtr: true
    })
  }
  calculatePositionTableName() {
    let text = this.tableName;
    text.left = this.position.left + this.width / 2
    text.top = this.position.top + this.height / 2
  }
}
